import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import qs from 'qs';

export interface IResponse {
    url: string;
}

export const getComparisonPdf = async (orgId: string, dealId: number, scenarioIds: number[]): Promise<IResponse> => {
    const queryParams = qs.stringify({ scenario_ids: scenarioIds }, { arrayFormat: 'repeat' });
    const response = await axiosInstance.get(`${API_ENDPOINTS.BOE_SCENARIO_COMP_PDF(orgId, dealId)}?${queryParams}`);
    return response.data;
};

export const useGetComparisonPdf = (
    orgId: string,
    dealId: number,
    scenarioIds: number[] = [],
    options: { enabled: boolean },
) => useQuery({
    queryKey: [QUERY_KEYS.BOE.SCENARIO_COMPARISON_PDF, orgId, dealId, scenarioIds],
    queryFn: () => getComparisonPdf(orgId, dealId, scenarioIds),
    ...options,
});

export default useGetComparisonPdf;
